<div class="container">
  <div class="filter-container">
    <app-global-reporting-filters
      showModelOnly="false"
      [isSearchFilter]="showSearch"
      [exportColumns]="exportColumns"
      [exportKey]="exportKey"
      (isFilterValueChange)="toggleFilter($event)"
      (onReloadGrid)="onReloadGrid()"
    ></app-global-reporting-filters>
  </div>
  <div class="grid-container all-brokers">
    <app-ark-container
      [future]="dataObservable"
      [loadingTemplate]="loading"
      [successTemplate]="success"
      [failureTemplate]="failure"
      [errorTemplate]="error"
      (onFailure)="handleFailure($event)"
      (onSuccess)="onDataResolved($event[0])"
    >
    </app-ark-container>
    <ng-template #loading>
      <div class="section">
        <va-custom-skeleton
          [customSkeletonConfig]="{
            skeletonType: 'list',
            config: {
              list: {
                noOfListItems: 11
              }
            }
          }"
        ></va-custom-skeleton>
      </div>
    </ng-template>
    <ng-template #failure>
      <div class="error-container">
        <div class="error-msg">
          <span class="error-text">{{ errorMsg }}</span>
        </div>
      </div>
    </ng-template>
    <ng-template #error>
      <div class="error-container">
        <div class="error-msg">
          <span class="error-text">{{ errorMsg }}</span>
        </div>
      </div>
    </ng-template>
    <ng-template #success>
      <div class="reporting-grid">
        <va-custom-grid
          (sortChange)="onSortChange($event)"
          (paginationChange)="getNextPageData($event)"
          (filterChange)="filterApplied($event)"
          [loading]="isLoading"
          [gridHeight]="gridHeight"
          [showTotalCount]="true"
          [columnsData]="columns.columnsData"
          [totalCount]="totalResultCount"
          [isFrontPagination]="false"
          [data]="data"
          [fields]="columns.columnFields"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          [bordered]="false"
          [widthConfig]="columns.widthConfig"
          [showInternalFilters]="showGridFilters"
          [skeletonType]="'grid'"
          [gridSkeletonRows]="skeletonRows"
          [gridSkeletonCol]="skeletonCol"
        ></va-custom-grid>
      </div>
    </ng-template>
  </div>
</div>
